import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Calendar } from "lucide-react";
import api from "@/lib/api";

export default function TradingIdeaDetail() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/content/trading_ideas/${id}`).then((r) => setItem(r.data)).catch(() => setErr(true));
  }, [id]);

  if (err) return <div className="cb-container py-24"><p className="text-slate-500">Idea not found. <Link to="/" className="gold-text">Back to home</Link></p></div>;
  if (!item) return <div className="cb-container py-24 text-slate-500">Loading…</div>;

  const bear = /bear/i.test(item.bias || "");
  const neutral = /neutral/i.test(item.bias || "");
  const biasCls = neutral ? "bg-slate-100 text-slate-600" : bear ? "bg-red-50 text-red-600" : "bg-emerald-50 text-emerald-700";

  return (
    <article className="py-16 sm:py-24 bg-white">
      <div className="cb-container max-w-3xl">
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#D8AE4E] mb-8" data-testid="idea-back"><ArrowLeft size={16} /> Back to home</Link>
        <div className="flex items-center gap-3 mb-3">
          {item.instrument && <span className="overline">{item.instrument}</span>}
          {item.bias && <span className={`text-[11px] font-semibold px-2 py-0.5 rounded ${biasCls}`} data-testid="idea-bias">{item.bias}</span>}
        </div>
        <h1 className="font-serif font-bold text-3xl sm:text-4xl text-[#0B1D40] leading-tight" data-testid="idea-title">{item.title}</h1>
        <div className="flex items-center gap-2 text-sm text-slate-500 mt-4 mb-8"><Calendar size={14} className="gold-text" /><span className="font-mono">{new Date(item.date || item.created_at).toLocaleDateString()}</span></div>
        {item.chart_image && <img src={item.chart_image} alt={`${item.instrument} chart`} className="w-full rounded-md mb-8 border border-slate-200" data-testid="idea-chart" />}
        {item.summary && <p className="text-lg text-slate-700 leading-relaxed mb-6">{item.summary}</p>}
        {item.body && <div className="max-w-none text-slate-700 leading-relaxed whitespace-pre-line" data-testid="idea-body">{item.body}</div>}
        <p className="text-xs text-slate-400 mt-10 border-t border-slate-200 pt-5">Educational market commentary — not investment advice. Indicative levels only.</p>
      </div>
    </article>
  );
}
